export function toMonthKey(d: Date) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function monthLabel(key: string) {
  const [y, m] = key.split("-");
  return `Tháng ${parseInt(m)}/${y}`;
}

export function prevMonthKey(key: string) {
  const [y, m] = key.split("-").map(Number);
  return toMonthKey(new Date(y, m - 2));
}

export function nextMonthKey(key: string) {
  const [y, m] = key.split("-").map(Number);
  return toMonthKey(new Date(y, m));
}

export function currentMonthKey() {
  return toMonthKey(new Date());
}
